import React from 'react'
import { AddNew } from '../../components/AddNew'


export const AddNewPage = () => {
  return <AddNew/>
}
